/* Reveals elements as they enter the viewport.

   The hidden state lives in CSS behind .ql-motion, which the inline snippet in
   theme.liquid sets. That snippet also arms a failsafe timer, so if this file
   fails to load the page still shows its content. */
(function () {
  var SELECTOR = [
    '.ql-reveal',
    '.collection-list__item',
    '.featured-collection .grid__item',
    '.rich-text__wrapper',
    '.multicolumn-list__item',
    '.home-video__media'
  ].join(',');

  function revealAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('ql-revealed');
    });
  }

  // Tell the failsafe we made it.
  window.__qlRevealReady = true;

  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    revealAll();
    document.addEventListener('DOMContentLoaded', function () { revealAll(); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ql-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function observe(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el, i) {
      if (el.dataset.qlObserved) return;
      el.dataset.qlObserved = '1';
      // Stagger siblings so grids cascade instead of popping in together.
      if (!el.style.getPropertyValue('--ql-reveal-delay')) {
        el.style.setProperty('--ql-reveal-delay', Math.min(i % 4, 3) * 70 + 'ms');
      }
      observer.observe(el);
    });
  }

  observe(document);
  document.addEventListener('DOMContentLoaded', function () { observe(document); });

  // The theme editor swaps sections in without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
